import type { WidgetDefinition } from '../WidgetDefinition';
import { ordersWidgetDefinition } from './orders';
import { faClipboardList } from '@fortawesome/pro-regular-svg-icons/faClipboardList';
import type { OrdersWidgetModel } from '@thinkalpha/ui-types/contracts/workspace';
import type { OrdersWidgetViewModel } from 'src/store/types';

class ManualReviewWidgetDefinition implements WidgetDefinition<OrdersWidgetViewModel, OrdersWidgetModel> {
    type = 'manual-review' as const;
    nameKey = 'widgets::manual-review::name' as const;
    roles = ['widgets::manual-review'];
    icon = faClipboardList;
    category = 'widgets::categories::risk' as const;
    toViewModel = ordersWidgetDefinition.toViewModel;
    toContractModel = ordersWidgetDefinition.toContractModel;
}

export const manualReviewWidgetDefinition = new ManualReviewWidgetDefinition();
